module.exports = __webpack_public_path__ + "static/img/9.40e2a7d6.png";